const DEFAULT_SERVER_IP = "localhost";
const DEFAULT_BACKEND_PORT = "8001";

const envBaseUrl = process.env.REACT_APP_BACKEND_URL;
const fallbackBaseUrl = `http://${DEFAULT_SERVER_IP}:${DEFAULT_BACKEND_PORT}`;

// Accept a server URL or an API URL, including the same-origin "/api".
// Auth and Basic callers append /api themselves and need the server base.
const baseUrl = (envBaseUrl || fallbackBaseUrl).replace(/\/+$/, "");
export const BACKEND_BASE_URL = baseUrl.replace(/\/api$/, "");
export const API_BASE_URL = `${BACKEND_BASE_URL}/api`;

